const API_URL = window.location.origin.includes("localhost")
  ? import.meta.env.VITE_API_URL
  : window.location.origin;

export { API_URL };
